import { SVGProps } from 'react';

export const WorkInProgress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3H9L7 11H11L13 3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 3H18V0H16V3L14 11H16V15H4V11L6 3H4V0H2V3H1C0.448 3 0 3.448 0 4V10C0 10.552 0.448 11 1 11H2V20H4V17H16V20H18V11H19C19.552 11 20 10.552 20 10V4C20 3.448 19.552 3 19 3Z"
      fill="currentColor"
    />
  </svg>
);
